<template>
  <div class="account-empty">
    <div class="account-empty-top">
      <div class="account-empty-top-left">
        <p class="top-title">{{$t('message.collection.emptyTopTitle')}}</p>
        <p class="top-desc">
          {{$t('message.collection.emptyTopDesc01')}}<br />
          {{$t('message.collection.emptyTopDesc02')}}
        </p>
      </div>
      <div class="account-empty-top-right">
        <el-button v-permission="'collection:virtualAccount:list:create'" type="primary" @click="handleCreate">
          {{`${app.userLogin.businessType}` === '0' ? $t('message.collection.createVirtualAccount1') : $t('message.collection.createVirtualAccount')}}
        </el-button>
      </div>
    </div>
    <div class="account-empty-bottom">
      <div class="account-empty-bottom-left">
        <div class="func-list">
          <div class="func-item">
            <div class="img-box"><img src="../../../../assets/images/collection/img1.png"/></div>
            <p class="func-item-title">{{$t('message.collection.emptyContentTitle01')}}</p>
            <p class="func-item-desc">{{$t('message.collection.emptyContentDesc01')}}</p>
          </div>
          <div class="func-item">
            <div class="img-box"><img src="../../../../assets/images/collection/img2.png"/></div>
            <p class="func-item-title">{{$t('message.collection.emptyContentTitle02')}}</p>
            <p class="func-item-desc">{{$t('message.collection.emptyContentDesc02')}}</p>
          </div>
        </div>
        <div class="func-list">
          <div class="func-item">
            <div class="img-box"><img src="../../../../assets/images/collection/img3.png" /></div>
            <p class="func-item-title">{{$t('message.collection.emptyContentTitle03')}}</p>
            <p class="func-item-desc">{{$t('message.collection.emptyContentDesc03')}}</p>
          </div>
          <div class="func-item">
            <div class="img-box"><img src="../../../../assets/images/collection/img4.png"/></div>
            <p class="func-item-title">{{$t('message.collection.emptyContentTitle04')}}</p>
            <p class="func-item-desc">{{$t('message.collection.emptyContentDesc04')}}</p>
          </div>
        </div>
      </div>
      <div class="account-empty-bottom-right">
        <img class="bg-empty" src="../../../../assets/images/collection/bg-empty.png" />
        <div class="bottom-right-shadow"></div>
        <div class="bottom-right-content">
          <div class="dot-box">
            <span class="dot-item"></span>
            <span class="dot-item"></span>
            <span class="dot-item"></span>
          </div>
          <div class="right-content-left">
            <div v-for="(item, index) in currencyList" :key="index" class="right-content-item">
              <img :src="item.icon" />
              <div class="currency-info">
                <p class="currency-title">{{item.title}}</p>
                <p class="currency-desc">{{item.desc}}</p>
              </div>
              <span class="amount">{{item.amount}}</span>
            </div>
          </div>
          <div class="right-content-right">
            <div class="content-right-top">
              <img :src="currencyList[0].icon" />
              <div class="currency-info">
                <p class="currency-title">{{currencyList[0].title}}</p>
                <p class="currency-desc">{{currencyList[0].desc}}</p>
              </div>
            </div>
            <div class="content-right-info">
              <div v-for="(item, index) in currencyInfo" :key="index" class="right-info-item">
                <p class="info-item-title">{{item.title}}</p>
                <p class="info-item-desc">{{item.desc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currencyList: [{
        icon: require('@/assets/images/currency/USD.png'),
        title: 'USD',
        desc: 'US dollar',
        amount: '+ $ 4506.00',
      }, {
        icon: require('@/assets/images/currency/JPY.png'),
        title: 'JPY',
        desc: 'Japanese Yen',
        amount: '+ ¥ 890.00',
      }, {
        icon: require('@/assets/images/currency/GBP.png'),
        title: 'GBP',
        desc: 'United Kingdom',
        amount: '+ £ 87.00',
      }, {
        icon: require('@/assets/images/currency/EUR.png'),
        title: 'EUR',
        desc: 'Europe',
        amount: '+ € 506.00',
      }],
      currencyInfo: [{
        title: 'Account number',
        desc: '3000203451111',
      }, {
        title: 'Pre recorded amount',
        desc: '0.00',
      }, {
        title: 'Amount in withdrawal',
        desc: '0.00',
      }],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  methods: {
    handleCreate() {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      this.$emit('create');
    },
  },
};
</script>

<style lang="scss" scope>
@import "@/styles/variables.scss";

.account-empty {
  height: calc(100vh - 70px - 100px);
  padding-top: 9px;
  box-sizing: border-box;
  &-top {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f1f5f7;
    border-radius: 2px;
    padding-top: 18px;
    padding-bottom: 20px;
    padding-left: 25px;
    padding-right: 40px;
    z-index: 10;

    &-left {
      .top-title {
        font-size: 18px;
        font-weight: bold;
        color: $color-text-primary;
        line-height: 22px;
        margin-bottom: 14px;
      }

      .top-desc {
        font-size: 14px;
        font-weight: 400;
        color: $color-text-primary;
        line-height: 26px;
      }
    }
  }

  &-bottom {
    position: relative;
    margin-top: 88px;

    &-left {
      position: relative;
      z-index: 10;
    }

    .func-list {
      display: flex;
      margin-bottom: 25px;

      .func-item {
        width: 21%;
        margin-right: 35px;

        .img-box {
          height: 51px;
          margin-bottom: 23px;
        }

        .func-item-title {
          font-size: 18px;
          font-weight: bold;
          color: $color-text-primary;
          line-height: 22px;
          margin-bottom: 14px;
        }

        .func-item-desc {
          font-size: 14px;
          font-weight: 400;
          color: $color-text-primary;
          line-height: 22px;
        }
      }
    }

    &-right {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;

      .bg-empty {
        position: absolute;
        width: auto;
        height: 634px;
        right: -7px;
        top: -150px;
        z-index: 0;
      }

      .bottom-right-shadow {
        position: relative;
        width: 495px;
        height: 302px;
        background: #F1F5F7;
        border-radius: 10px;
        z-index: 10;
      }

      .bottom-right-content {
        display: flex;
        position: absolute;
        top: 32px;
        right: 20px;
        width: 519px;
        height: 338px;
        background: #FFFFFF;
        box-shadow: 20px 12px 48px 0px rgba(0,0,0,0.1);
        border-radius: 10px;
        padding-top: 38px;
        padding-left: 10px;
        box-sizing: border-box;
        z-index: 11;

        .dot-box {
          position: absolute;
          top: 10px;
          left: 13px;

          .dot-item {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #E8E8E8;
            border-radius: 50%;
            margin-right: 7px;

            &:last-child {
              background: #9B9B9B;
            }
          }
        }

        .right-content-left {
          margin-right: 10px;
          .right-content-item {
            display: flex;
            align-items: center;
            width: 315px;
            height: 61px;
            border-radius: 4px;
            margin-bottom: 10px;
            padding-left: 18px;
            padding-right: 16px;
            box-sizing: border-box;

            &:first-child {
              background: #F1F5F7;
            }

            & > img {
              width: 31px;
              height: 31px;
            }

            .currency-info {
              flex: 1;
              margin-left: 14px;

              .currency-title {
                font-size: 14px;
                font-family: Avenir-Heavy, Avenir;
                font-weight: 800;
                color: $color-text-primary;
                line-height: 24px;
              }

              .currency-desc {
                font-size: 12px;
                font-family: Avenir-Medium, Avenir;
                font-weight: 500;
                color: $color-text-primary;
                line-height: 16px;
              }
            }

            .amount {
              font-size: 12px;
              font-weight: bold;
              color: $color-text-default-button;
              line-height: 14px;
            }
          }
        }

        .right-content-right {
          width: 169px;
          height: 281px;
          background: #F1F5F7;
          border-radius: 8px;
          padding-left: 14px;
          padding-top: 15px;
          box-sizing: border-box;

          .content-right-top {
            display: flex;
            margin-bottom: 20px;
            & > img {
              width: 24px;
              height: 24px;
            }

            .currency-info {
              flex: 1;
              margin-left: 8px;

              .currency-title {
                font-size: 11px;
                font-family: Avenir-Heavy, Avenir;
                font-weight: 800;
                color: $color-text-primary;
                line-height: 13px;
              }

              .currency-desc {
                font-size: 9px;
                font-family: Avenir-Medium, Avenir;
                font-weight: 500;
                color: $color-text-primary;
                line-height: 12px;
              }
            }
          }

          .content-right-info {
            .right-info-item {
              color: $color-text-primary;
              margin-bottom: 10px;
              .info-item-title {
                font-size: 9px;
                font-weight: 400;
                line-height: 12px;
                margin-bottom: 5px;
              }
              .info-item-desc {
                font-size: 11px;
                font-weight: bold;
                line-height: 13px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
